var _defs, _path, _path2, _path3, _path4, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.57,30.45a1,1,0,0,1-.71-.3,1,1,0,0,1,0-1.41,12.28,12.28,0,0,0,0-17.35,1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0,14.27,14.27,0,0,1,0,20.18A1,1,0,0,1,40.57,30.45Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.46,32a11.91,11.91,0,1,1,11.9-11.91A11.92,11.92,0,0,1,26.46,32Zm0-21.81a9.91,9.91,0,1,0,9.9,9.9A9.92,9.92,0,0,0,26.46,10.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.86,51.84a1,1,0,0,1-1-1V46.07c0-3.71-1.75-6.66-5.2-8.76a1,1,0,0,1-.34-1.37,1,1,0,0,1,1.37-.34,11.85,11.85,0,0,1,6.17,10.47v4.77A1,1,0,0,1,50.86,51.84Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.78,51.84a1,1,0,0,1-1-1V46.07c0-2.13,0-8.61-16.32-8.61s-16.32,6.48-16.32,8.61v4.77a1,1,0,0,1-2,0V46.07c0-7,6.16-10.61,18.32-10.61S44.78,39,44.78,46.07v4.77A1,1,0,0,1,43.78,51.84Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 60,
    height: 60
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.f57a584578260a3a42b605e897ce5db6.svg";
export { ForwardRef as ReactComponent };